import React, { Component } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import Page from "../../../components/Page";
import moment from "moment";
import { getPositions } from "../../../api-requests/position";
import { getQualifications } from "../../../api-requests/qualification";
import AccordionJobs from "../../../components/AccordionJobs";
import { getJobsForGuest } from "../../../api-requests/job";
import { getMinMaxSize, getMinMaxAge, getMinMaxSalary } from "../../../helpers/job";
import Filter from "../../../components/Filter";
import { convertQueryStringToObject } from "../../../helpers/reset-password";
import NavigationBar from "../../../components/NavigationBar";
import WebFooter from "../../../components/WebFooter";

class FindJobs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: [],
            qualifications: [],
            positions: [],
            jobs: [],
            keyword: "",
            showFilter: false,
            selectedPositions: "",
            selectedJobTypes: "",
            selectedQualifications: [],
            selectedCoupleFriendly: [],
            selectedYachtTypes: [],
            selectedYachtSizes: [],
            selectedYachtAges: [],
            selectedSalaryRanges: [],
        };

    }

    componentDidMount() {

        document.title = "Find Yacht Crew Jobs - J4Crew";
        const data = convertQueryStringToObject(this.props.location.search);

        if (data.keyword) {
            this.setState({ keyword: data.keyword });
        }

        return getJobsForGuest()
            .then(jobs => {
                return this.setState({ jobs: jobs });
            });

    }

    toggleFilter = (state) => {

        if (this.state.positions.length < 1) {
            getPositions()
                .then(result => {
                    if (result.status !== 201) return;
                    return this.setState({ positions: result.data });
                });
        }

        if (this.state.qualifications.length < 1) {
            getQualifications()
                .then(result => {
                    if (result.status !== 201) return;
                    return this.setState({ qualifications: result.data });
                });
        }

        if (!state) this.setState({ keyword: "" });

        return this.setState({
            showFilter: !state,
            selectedPositions: "",
            selectedJobTypes: "",
            selectedQualifications: [],
            selectedCoupleFriendly: [],
            selectedYachtTypes: [],
            selectedYachtSizes: [],
            selectedYachtAges: [],
            selectedSalaryRanges: [],
        });
    }

    handleSuggestions = (state, jobs) => {
        return this.filterJobs(state, jobs);
    }

    handleFilterClick = (type, expandedFilter) => {

        if (type === expandedFilter) return this.setState({ expandedFilter: "" });

        return this.setState({ expandedFilter: type });

    }

    handleOptionClick = (propName, item, single) => {

        if (this.state[propName].includes(item)) return this.setState({ [propName]: this.state[propName].filter(i => i !== item) });

        if (!single) return this.setState({ [propName]: [...this.state[propName], item] });

        return this.setState({ [propName]: [item] });

    }

    filterJobs = (state, jobs) => {

        if (state.keyword && state.keyword.trim().length > 0) {
            const kw = state.keyword.trim().toLowerCase();
            jobs = jobs.filter(job => {
                const positionName = job.position && job.position.name ? job.position.name.toLowerCase() : "";
                const positionType = job.position && job.position.positionType ? job.position.positionType.toLowerCase() : "";
                const yachtName = job.yacht && job.yacht.name ? job.yacht.name.toLowerCase() : "";
                const yachtType = job.yacht && job.yacht.yachtType ? job.yacht.yachtType.toLowerCase() : "";
                const qualMatch = job.qualifications && job.qualifications.some(q => q.name && q.name.toLowerCase().includes(kw));
                return positionName.includes(kw) || positionType.includes(kw) || yachtName.includes(kw) || yachtType.includes(kw) || qualMatch;
            });
        }

        if (state.selectedPositions.length > 0) {
            jobs = jobs.filter(job => {
                return job.position.name.toLowerCase().includes(state.selectedPositions.toLowerCase());
            });
        }

        if (state.selectedJobTypes.length > 0) {
            jobs = jobs.filter(job => {
                return job.position.positionType.toLowerCase().includes(state.selectedJobTypes.toLowerCase())
            });
        }

        if (state.selectedYachtTypes.length > 0) jobs = jobs.filter(job => state.selectedYachtTypes.includes(job.yacht.yachtType));

        if (state.selectedQualifications.length > 0) {
            jobs = jobs.filter(job => {
                let matches = job.qualifications.filter(qualification => state.selectedQualifications.includes(qualification.name));
                return matches.length > 0;
            });
        }

        if (state.selectedCoupleFriendly.length > 0) {
            jobs = jobs.filter(job => {
                let match = job.yacht.couples ? "Yes" : "No";
                return state.selectedCoupleFriendly.includes(match);
            });
        }

        if (state.selectedYachtSizes.length > 0) {
            jobs = jobs.filter(job => {
                let match = state.selectedYachtSizes.map(size => {
                    let minMaxSize = getMinMaxSize(size);
                    if (minMaxSize.max) return minMaxSize.min <= job.yacht.size && job.yacht.size <= minMaxSize.max;
                    return minMaxSize.min <= job.yacht.size;
                });
                return match.includes(true);
            });
        }

        if (state.selectedYachtAges.length > 0) {
            jobs = jobs.filter(job => {
                let match = state.selectedYachtAges.map(age => {
                    let minMaxAge = getMinMaxAge(age);
                    let yachtAge = job.yacht.age,
                        currentYear = moment(new Date()).year(),
                        yearDifference = currentYear - yachtAge;

                    if (minMaxAge.min && minMaxAge.max) return minMaxAge.min <= yearDifference && yearDifference <= minMaxAge.max;
                    if (minMaxAge.min) return minMaxAge.min <= yearDifference;

                    return yearDifference <= minMaxAge.max;
                });
                return match.includes(true);
            });
        }

        if (state.selectedSalaryRanges.length > 0) {
            jobs = jobs.filter(job => {
                if (job.salaryType === "DOE" && state.selectedSalaryRanges.includes("Salary DOE")) return true;

                let amount;
                let salaryAmount = job.salaryType === "Fixed" ? parseInt(job.salaryAmount, 10) : (parseInt(job.salaryRangeMin, 10) + parseInt(job.salaryRangeMax, 10)) / 2;

                if (!job.salaryCurrency || !salaryAmount) amount = 0;
                if (job.salaryCurrency === "usd") amount = salaryAmount*0.9;
                if (job.salaryCurrency === "gbp") amount = salaryAmount*1.1;
                if (job.salaryCurrency === "eur") amount = salaryAmount;

                let match = state.selectedSalaryRanges.map(salary => {
                    if (salary === "Salary DOE") return false;
                    let minMaxSalary = getMinMaxSalary(salary);
                    if (minMaxSalary.max) return minMaxSalary.min <= amount && amount <= minMaxSalary.max;
                    return minMaxSalary.min <= amount;
                });
                return match.includes(true);

            });
        }

        return jobs;

    }

    searchKeyword = (e, propName) => {
        return this.setState({ [propName]: e });
    }

    render() {

        let suggestions = this.handleSuggestions(this.state, this.state.jobs);
        const totalJobs = this.state.jobs.length;
        const resultsLabel = this.state.keyword
            ? `${suggestions.length} ${suggestions.length === 1 ? "result" : "results"}`
            : `${totalJobs} ${totalJobs === 1 ? "role" : "roles"} open`;

        return(
            <Page match={this.props.match} hideNavbar={true}>
                <div className="page-intro-linear-container find-jobs-hero">
                    <NavigationBar { ...this.props } />
                    <div className="find-jobs-hero-content">
                        <span className="find-jobs-hero-eyebrow">Open roles</span>
                        <h1>Find your next yacht role</h1>
                        <p>Browse our current vacancies. Log in or register to apply.</p>
                        <div className="find-jobs-hero-search">
                            <img src={require("../../../assets/svgs/search.svg")} alt="" />
                            <input
                                type="text"
                                placeholder="Search by role, vessel, or qualification"
                                value={this.state.keyword}
                                onChange={(e) => this.setState({ keyword: e.target.value })}
                            />
                            {this.state.keyword && (
                                <button
                                    type="button"
                                    className="find-jobs-hero-search-clear"
                                    onClick={() => this.setState({ keyword: "" })}
                                    aria-label="Clear search"
                                >×</button>
                            )}
                        </div>
                        <div className="find-jobs-hero-meta">
                            <span className="find-jobs-hero-count">{resultsLabel}</span>
                            <span className="find-jobs-hero-divider">·</span>
                            <Link to={"/sign-in"}>Log in</Link>
                            <span className="find-jobs-hero-divider">·</span>
                            <Link to={"/sign-up"}>Register</Link>
                        </div>
                    </div>
                </div>
                <div className="find-jobs-container">
                    <div className="find-jobs-wrapper">
                        {suggestions.length > 0 ? (
                            <AccordionJobs
                                guest={true}
                                jobs={suggestions}
                                expanded={this.state.expanded}
                                handleRow={(result) => this.setState({ expanded: result })}
                            />
                        ) : (
                            <div className="find-jobs-empty">
                                <p>No roles match {this.state.keyword ? `"${this.state.keyword}"` : "your search"} right now.</p>
                                {this.state.keyword && (
                                    <button
                                        type="button"
                                        className="find-jobs-empty-clear"
                                        onClick={() => this.setState({ keyword: "" })}
                                    >Clear search</button>
                                )}
                            </div>
                        )}
                    </div>
                    <WebFooter />
                </div>
            </Page>
        );

    }

}

export default FindJobs;
